export class Procedure {

	public appelRestreint: string;

	public procedureAdaptee: string;

	public marcheNegocie: string;

	public appelOuvert: string;

	public concoursRestreint: string;

	public dialogueCompetitif: string;

	public concoursOuvert: string;

	public autres: string;

	constructor() { 
		 		this.appelRestreint = '';
		this.procedureAdaptee = '';
		this.marcheNegocie = '';
		this.appelOuvert = '';
		this.concoursRestreint = '';
		this.dialogueCompetitif = '';
		this.concoursOuvert = '';
		this.autres = '';
 
	}
}
